<script>
  import { createEventDispatcher } from "svelte";
  import { Card, CardContent, Icon, Badge } from "framework7-svelte";

  export let title = "";
  export let value = "0";
  export let subtitle = "";
  export let icon = "";
  export let iconColor = "#2563eb";
  export let badge = "";
  export let badgeColor = "blue";
  export let theme = "default"; // default, success, danger, warning, purple, info
  export let clickable = false;
  export let active = false;

  const dispatch = createEventDispatcher();

  function handleClick() {
    if (clickable) {
      dispatch("click");
    }
  }
</script>

<div
  class="kpi-stat-card theme-{theme}"
  class:is-clickable={clickable}
  class:is-active={active}
  on:click={handleClick}
>
  <div class="kpi-card-header">
    <div class="kpi-title-block">
      {#if icon}
        <span class="kpi-icon-wrap" style="color: {iconColor};">
          {#if icon.startsWith("f7:")}
            <Icon f7={icon.replace("f7:", "")} size="20px" />
          {:else if icon.startsWith("material:")}
            <Icon material={icon.replace("material:", "")} size="20px" />
          {:else}
            <span class="kpi-emoji">{icon}</span>
          {/if}
        </span>
      {/if}
      <span class="kpi-title">{title}</span>
    </div>

    {#if badge}
      <Badge color={badgeColor} class="kpi-badge">{badge}</Badge>
    {/if}
  </div>

  <div class="kpi-value-block">
    <div class="kpi-value">{value}</div>
    {#if subtitle}
      <div class="kpi-subtitle">{subtitle}</div>
    {/if}
  </div>
</div>

<style>
  .kpi-stat-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.15s ease-in-out;
    height: 100%;
    box-sizing: border-box;
  }

  .kpi-stat-card.is-clickable {
    cursor: pointer;
  }

  .kpi-stat-card.is-clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
  }

  .kpi-stat-card.is-active {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
    background: #f8fafc;
  }

  .kpi-stat-card.theme-success {
    border-left: 4px solid #10b981;
  }

  .kpi-stat-card.theme-danger {
    border-left: 4px solid #ef4444;
  }

  .kpi-stat-card.theme-warning {
    border-left: 4px solid #f59e0b;
  }

  .kpi-stat-card.theme-purple {
    border-left: 4px solid #8b5cf6;
  }

  .kpi-stat-card.theme-info {
    border-left: 4px solid #0284c7;
  }

  .kpi-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .kpi-title-block {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .kpi-icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .kpi-emoji {
    font-size: 18px;
    line-height: 1;
  }

  .kpi-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
  }

  .kpi-value-block {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .kpi-value {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    word-break: break-all;
  }

  .kpi-subtitle {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
  }
</style>
